import React from 'react'
import PropTypes from 'prop-types'
import './Dropdown.sass'
import ToggleOpen from '../../decorators/ToggleOpen'
import UserRole from './UserRole'

class DropdownUser extends React.PureComponent {
  /* eslint-disable */
  static propTypes = {
    listRoles: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired
  }

  render () {
    const {children, listRoles, isOpen, handleClick, current_user} = this.props
    return (
      <li className="nav-list__dropdown nav-list__dropdown-user">
        <a className={`nav-list__dropdown-caption nav-list__dropdown-caption--user ${isOpen ? 'active':''}`} onClick={handleClick}>
          {children}
        </a>
        {isOpen &&
          <ul className="dropdown">
            <div className="overlay" onClick={handleClick} />
            <li className="dropdown__row-top">
              {listRoles && <UserRole listRoles={listRoles} current_user={current_user} />}
              <a className="dropdown__row-top-user--exit" href="/session/logout">Выход</a>
            </li>
          </ul>
        }
      </li>
    )
  }
}

export default ToggleOpen(DropdownUser)



// WEBPACK FOOTER //
// ./components/DropdownUser/index.jsx